module.exports = __webpack_public_path__ + "static/balance-time-money-de3421f9f29dfe6dc0604202299031b4.png";